/**
 * @desc undefined
 */
import { BankForm } from '@eastcoal/api/finance/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateOrUpdateBankParameter = BankForm

const method = 'POST'
const url = '/finance/bank'

export const createOrUpdateBankApi = (
  data?: CreateOrUpdateBankParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

createOrUpdateBankApi.method = method
createOrUpdateBankApi.url = url
